import moment from "moment";
import { roundToNearestHalfHour } from "./roundToNearestHalfHour";
import { isOverlapping } from "./isOverlapping";

export const checkApartadoIndividual = (secludedClassrooms, salon, element) => {
  const day = element[0].slice(0, 3);
  return secludedClassrooms?.salon?.some((classRoon, index) => {
    const isSameClassRoon = salon.name === classRoon;
    const isStatus = secludedClassrooms?.estatus[index];

    if (isSameClassRoon && isStatus) {
      const isSameDate = secludedClassrooms?.dias[index]
        ?.toLowerCase()
        ?.split(",")
        ?.includes(day);

      const initialHour = moment(
        roundToNearestHalfHour(
          secludedClassrooms?.horario[index]?.split(" - ")[0]
        ),
        "HH:mm"
      );
      const finalHour = moment(
        roundToNearestHalfHour(
          secludedClassrooms?.horario[index]?.split(" - ")[1]
        ),
        "HH:mm"
      );
      const checkHour = moment(element[1], "HH:mm");
      const isOcupate = checkHour.isBetween(initialHour, finalHour, null, "[]");
      if (isOcupate && isSameDate) {
        return true;
      }
      return false;
    }
    return false;
  });
};

export const checkApartadoFecha = (secludedClassrooms, salon, element) => {
  const { day, initial, final } = element;
  return secludedClassrooms?.salon?.some((classRoon, index) => {
    const isSameClassRoon = salon.name === classRoon;
    const isStatus = secludedClassrooms?.estatus[index];

    if (isSameClassRoon && isStatus) {
      const isSameDate = secludedClassrooms?.dias[index]
        ?.toLowerCase()
        ?.split(",")
        ?.includes(day);

      const initialHour = secludedClassrooms?.horario[index]?.split(" - ")[0];
      const finalHour = secludedClassrooms?.horario[index]?.split(" - ")[1];

      const isOcupate = isOverlapping(initialHour, finalHour, initial, final);

      if (isOcupate && isSameDate) {
        return true;
      }
      return false;
    }
    return false;
  });
};
